import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class DeleteAsset extends Component {

  static propTypes = {
    assetName: PropTypes.string,
    assetType: PropTypes.string,
    assetId: PropTypes.number,
    authenticityToken: PropTypes.string,
    url: PropTypes.string,
    returnUrl: PropTypes.string
  }

  constructor(props) {
    super(props)
  }

  deleteUrl(){
    return this.props.url + '?return_url=' + (this.props.returnUrl || "")
  }


  closeTray = (evt) => {
    var tray = document.querySelector(`#delete-asset-${this.props.assetId}`)
    tray.classList.remove('open')
  }

  render(){
    return(
      <div>
        <h3 className="text-center">
          Are you sure you want to delete the asset?
        </h3>
        <h4 className="text-center">
          {this.props.assetName}
        </h4>
        <a href={this.deleteUrl()} type="submit" name="confirm" className="button" data-method='delete'>Yes, I'm Sure</a>
        <button className='button button--secondary' onClick={this.closeTray} data-close-tray={`delete-asset-${this.props.assetId}`} type="button">Not Right Now</button>
      </div>
    );
  }
}
